import styled from "styled-components";
import IconButton from "../IconButton/icon-button.component";

export const Container = styled.div`
	position: relative;
	margin: 6px;
`;

export const ConversationFiltersButton = styled(IconButton)`
	border: solid 1px ${(props) => props.theme.colours.light_3};
	font-size: 1.4rem;
	height: 38px;
	width: 38px;
	margin-left: 3px;
	border-radius: 5px;
	margin-right: 3px;

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
		filter: grayscale(0.7);
	}
`;

export const FlexContainer = styled.div`
	justify-content: space-evenly;
	display: flex;
`;

export const FolderListWrapper = styled.div`
	flex: 3;
	margin-right: 3px;
`;

export const SelectButton = styled.button`
	border: solid 1px ${(props) => props.theme.colours.light_3};
	background: none;
	border-radius: 5px;
	height: 38px;
	width: 38px;
	margin-left: 3px;
	cursor: pointer;
	font-size: 1.4rem;
	display: flex;
	align-items: center;
	justify-content: center;
	i {
		color: grey;
	}
	&:hover {
		border-color: ${(props) => props.theme.colours.primary};
	}
	&.active {
		border-color: ${(props) => props.theme.colours.primary};
		i {
			color: ${(props) => props.theme.colours.primary};
		}
	}
`;

export const SelectAllRow = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 0 2px;
	min-height: 38px;
	.cancel-btn {
		border: solid 1px ${(props) => props.theme.colours.light_3};
		background: none;
		border-radius: 5px;
		height: 28px;
		width: 28px;
		cursor: pointer;
		color: grey;
		&:hover {
			border-color: ${(props) => props.theme.colours.primary};
			color: ${(props) => props.theme.colours.primary};
		}
	}
	.select-all-btn, .deselect-btn {
		border: solid 1px ${(props) => props.theme.colours.light_3};
		background: none;
		border-radius: 5px;
		height: 28px;
		padding: 0 8px;
		cursor: pointer;
		font-size: 0.8rem;
		&:hover {
			background: ${(props) => props.theme.colours.light_1};
		}
	}
	.confirm-archive-btn {
		border: solid 1px ${(props) => props.theme.colours.primary};
		background: ${(props) => props.theme.colours.primary};
		color: ${(props) => props.theme.colours.textLight};
		border-radius: 5px;
		height: 28px;
		padding: 0 10px;
		cursor: pointer;
		font-size: 0.8rem;
		margin-left: auto;
		&:hover {
			filter: brightness(0.92);
		}
		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}
	.selection-count {
		font-size: 0.8rem;
		color: grey;
		margin-left: 4px;
	}
`;

export const ButtonsContainer = styled.div`
	flex: 1;
	display: flex;
	justify-content: space-evenly;
	i {
		color: grey;
	}
	.filter-count {
		position: absolute;
		top: -5px;
		right: -5px;
		font-size: 0.8rem;
		height: 12px;
		width: 12px;
		color: ${(props) => props.theme.colours.light_0};
		background-color: ${(props) => props.theme.colours.primary};
		border-radius: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 3px;
	}
	.filter {
		position: relative;
		display: flex;
		justify-content: center;
	}
`;
